import styled from 'styled-components';
import { CompetencyGoal } from 'generated/graphql';
import GoalSkillScoreIndex from './GoalSkillScoreIndex';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { t } from 'i18next';

const StyledGoalSkillScore = styled.section`
	min-width: 200px;
	display: flex;
	flex-direction: column;
`;

const GoalSkillScoreBox = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.lightBlue};
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;
`;

const GoalSkillScoreDescription = styled.div`
	background: ${({ theme }) => theme.colors.whiteBlue};
	padding: 16px;
	display: flex;
	flex-direction: column;
	row-gap: 8px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.lightBlue};
`;

const Label = styled.h3`
	font-size: 12px;
	line-height: 16px;
	margin: 0 0 2px;
	font-weight: normal;
`;

const Description = styled.p`
	font-size: 16px;
	line-height: 16px;
	font-weight: bold;
`;

export default function GoalSkillScore({ goalCompetency }: { goalCompetency: CompetencyGoal }) {
	const { localize } = useLocalize();

	const competency = goalCompetency?.competency;
	const targetCompetencyLevel =
		goalCompetency && competency?.competencyLevelSet.levels[goalCompetency?.competencyLevelIndex];

	return (
		<StyledGoalSkillScore>
			<GoalSkillScoreBox>
				<GoalSkillScoreDescription>
					<div>
						<Label>{t('developmentPlan.index.goalSkillScore.competencyTitle')}</Label>
						<Description>{localize(competency.title).text}</Description>
					</div>
					{targetCompetencyLevel && (
						<div>
							<Label>{t('developmentPlan.index.goalSkillScore.targetLevel')}</Label>
							<Description>{localize(targetCompetencyLevel.title).text}</Description>
						</div>
					)}
				</GoalSkillScoreDescription>
				<GoalSkillScoreIndex goalCompetency={goalCompetency} />
			</GoalSkillScoreBox>
		</StyledGoalSkillScore>
	);
}
